import { c as _c } from "react/compiler-runtime";
import { getStayCount } from "@website/accommodation-ui/price-calendar-wrapper/helpers";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
interface Properties {
  stDate: string;
  rtDate: string;
  cityFromTitle: string;
  cityToTitle: string;
}
export const PriceCalendarHeader = t0 => {
  const $ = _c(6);
  const {
    stDate,
    rtDate,
    cityFromTitle,
    cityToTitle
  } = t0;
  let t1;
  if ($[0] !== rtDate || $[1] !== stDate) {
    t1 = numberConvert(getStayCount(rtDate, stDate), {
      locale: "fa"
    });
    $[0] = rtDate;
    $[1] = stDate;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const stayCount = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon className="text-base" name="date_range" variant="outlined" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `تقویم قیمتی ارزان‌ترین تورهای ${stayCount} شبه ${cityFromTitle} به ${cityToTitle}`;
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex items-center gap-1">{t2}<div className="text-on-surface-medium-emphasis text-xs">{t3}</div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};